import { getStrapiContentTypeName, getStrapiURL } from "@/lib/api-helpers";

// Client-side function to create a new confidential form submission.
// The recipient emails are NOT sent from the client — they live in the CMS and
// are resolved server-side by the backend lifecycle.
export async function createFormulierInzending(rawFormData: any) {
  return await fetch(`${getStrapiURL(`/api${getStrapiContentTypeName("formulier-inzendingen")}`)}`, {
    method: "POST",
    body: JSON.stringify({
      data: rawFormData,
    }),
    headers: {
      "Content-Type": "application/json",
    },
  });
}
